import type { AiActorGender } from "../../api/generated/model";
import female from "../../ui/assets/female-gender.svg";
import male from "../../ui/assets/male-gender.svg";
import other from "../../ui/assets/other-gender.svg";

/**
 * Live's genders for a team's actor (`avatarGenderOptions`): My Actors' filter and a new actor's
 * choice, each with live's icon (`assets/icons/<gender>-gender.svg`, copied as files: eJam's own
 * icons, design-system decision 28).
 */
export const GENDERS: { value: AiActorGender; label: string; icon: string }[] = [
  { value: "female", label: "Female", icon: female },
  { value: "male", label: "Male", icon: male },
  { value: "other", label: "Other", icon: other },
];
